import React, { useEffect, useMemo, useState } from 'react';
import Slider from 'react-slick';
import { NavLink } from 'react-router-dom';
import { getMenuItems } from '../../core/services/menu';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const SliderConstruction = () => {
  const [navLinks, setNavLinks] = useState([]);

  useEffect(() => {
    const fetchMenuItems = async () => {
      try {
        const data = await getMenuItems();
        setNavLinks(data); // Store the fetched menu items in state
      } catch (error) {
        console.error('Error fetching menu items:', error);
      }
    };

    fetchMenuItems();
  }, []);

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    centerMode: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    variableWidth: true, // Enable variableWidth for larger screens
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 2500,
    responsive: [
      {
        breakpoint: 1500, // Large desktop view (1440px range)
        settings: {
          slidesToShow: 4,
          centerMode: false, // Disable centerMode for better fit at 1440px
          variableWidth: false, // Disable variableWidth for consistent sizing
          slidesToScroll: 1,
          adaptiveHeight: false,
        },
      },
      {
        breakpoint: 1281, // small laptop view
        settings: {
          slidesToShow: 3,
          centerMode: false, // Disable centering for better alignment
          variableWidth: false, // Use uniform slide widths
          slidesToScroll: 1,
          adaptiveHeight: false, // Disable adaptive height for consistency
        },
      },
      {
        breakpoint: 980, // Tablet view
        settings: {
          centerMode: false, // Disable centering for better alignment
          variableWidth: false, // Use uniform slide widths
          slidesToShow: 2, // Show 2 slides for tablets
          slidesToScroll: 1,
          adaptiveHeight: false, // Disable adaptive height for consistency
        },
      },
      {
        breakpoint: 580, // Mobile view
        settings: {
          centerMode: false,
          variableWidth: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
        },
      },
    ],
  };

  const sliderLinks = useMemo(() => {
    if (navLinks.length === 0) {
      return [];
    }

    const productsMenu = navLinks.find((x) => x.menu_id === '5');
    const constructionMenu = navLinks.find((x) => x.menu_id === '7');

    return [
      productsMenu?.children[1],
      productsMenu?.children[0],
      constructionMenu?.children[1],
      constructionMenu?.children[3],
      productsMenu?.children[2],
      constructionMenu?.children[0],
      productsMenu?.children[6],
    ];
  }, [navLinks]);

  const sliderImages = [
    'images/hero-images/toys.jpg',
    'images/gas.jpeg',
    'images/hero-images/machinery.jpeg',
    'images/hero-images/pressure-equipment.jpg',
    'images/hero-images/lighter.jpg',
    'images/hero-images/construction-products.jpg',
    'images/hero-images/label-nrg-v1.png',
  ];

  const sliderDescriptions = [
    'საფრთხეს არ უნდა უქმნიდეს ბავშვის სოცოცხლესა და ჯანმრთელობას', // Toys
    'საფრთხეს არ უნდა უქმნიდეს სოცოცხლესა და ჯანმრთელობას', // Gas-powered equipment
    'უნდა აკმაყოფილებდნენ ჯანმრთელობისა და უსაფრთხოების მოთხოვნებს', // Machinery
    'საფრთხეს არ უნდა უქმნიდეს სოცოცხლესა და ჯანმრთელობას', // Paints and coatings
    'საფრთხეს არ უნდა უქმნიდეს სოცოცხლესა და ჯანმრთელობას', // Safety equipment
    'საფრთხეს არ უნდა უქმნიდეს სოცოცხლესა და ჯანმრთელობას', // Construction products
    'მოწყობილობებს თან უნდა ახლდეს ენერგოეტიკეტი', // Energy labeling
  ];

  return (
    <Slider {...settings} className='wrapper__slider-construction'>
      {sliderLinks.map((link, index) => (
        <div className='items image-container' key={index}>
          <NavLink to={link?.path || '#'} className='slider-link'>
            <img
              src={sliderImages[index]} // Using the corresponding image from the array
              className='images__construction'
              alt={link?.title || 'Slider Image'}
            />
            <div className='overlay-text'>
              <span>{link?.title}</span>
              <p style={{ color: '#fff' }} className='text-center'>
                {sliderDescriptions[index]}
              </p>
            </div>
          </NavLink>
        </div>
      ))}
    </Slider>
  );
};

export default SliderConstruction;
